import { render, staticRenderFns } from "./Blacklist.vue?vue&type=template&id=217c2160"
import script from "./Blacklist.vue?vue&type=script&lang=js"
export * from "./Blacklist.vue?vue&type=script&lang=js"
import style0 from "./Blacklist.vue?vue&type=style&index=0&id=217c2160&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports